import React, { Fragment, useRef } from "react";
// eslint-disable-next-line no-unused-vars
import Breadcrumb from "../../../layout/breadcrumb";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Donate from "./donate/index";
import Testimonials from "./testimonials";
import Features from "./features";

const Sample = (props) => {
    const donateSectionRef = useRef(null);

    // const executeScroll = () => donateSectionRef.current.scrollIntoView();

    return (
        <Fragment>
            {/* <Breadcrumb parent="Dashboard" title="Default" /> */}
            <Container fluid={true} className="my-4">
                <Row>
                    <Col sm="12">
                        <div className="pic d-flex p-2 justify-content-center flex-column"></div>
                        <Card className="mt-4">
                            <CardBody>
                                <p className="text-normal f-16">
                                    Infant India Look After Many Orphans
                                    Neglected By The Society.Homeless Leftout's,
                                    Infected By HIV AIDS Are Provided with best
                                    Education, Food, Clothing And Shelter,
                                    Teaches Them Yoga And Pranayam, Provide Them
                                    With Medical Help Like ART And Checkup Of
                                    CD4.
                                </p>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col xs={12} className="m-t-50">
                        <div ref={donateSectionRef}></div>
                    </Col>

                    <Donate />
                    <Col xs="12" className="m-t-50">
                        <h3 className="text-center">Our Ongoing Projects</h3>
                    </Col>
                    <Features />

                    <Col xs="12" className="m-t-50">
                        <Testimonials />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default Sample;
